import config from '../config.js';
import { authFetch } from '../utils/apiClient.js';

async function listFlowAssignments() {
  const res = await authFetch(`${config.backendUrl}/v1/flows`);
  if (!res.ok) throw new Error(`Failed to load flow assignments (${res.status})`);
  return res.json();
}

async function getFlowAssignment(flowKey) {
  const res = await authFetch(`${config.backendUrl}/v1/flows/${flowKey}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Failed to load flow assignment (${res.status})`);
  return res.json();
}

async function setFlowAssignment(flowKey, clientId) {
  const res = await authFetch(`${config.backendUrl}/v1/flows`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ flow_key: flowKey, client_id: clientId }),
  });
  if (!res.ok) throw new Error(`Failed to set flow assignment (${res.status})`);
  return res.json();
}

export const flowAssignmentApi = { listFlowAssignments, getFlowAssignment, setFlowAssignment };
